module.exports = __webpack_public_path__ + "img/b1-dub.bad04574.jpg";